import { render } from "./BookingFormEmergencyContact.vue?vue&type=template&id=0b2e858a&scoped=true"
import script from "./BookingFormEmergencyContact.vue?vue&type=script&lang=js"
export * from "./BookingFormEmergencyContact.vue?vue&type=script&lang=js"

import "./BookingFormEmergencyContact.vue?vue&type=style&index=0&id=0b2e858a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2e858a"]])

export default __exports__